import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	button: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
			opacity: 0.9
		}
	},
	contentContainer: {
		display: "flex",
		justifyContent: "center"
	}
}))

export default useStyles
